import { useEffect, useRef, useState } from "react";
import { ImagePlus, Mic, Square, X } from "lucide-react";
import { useMemoryRecorder } from "./useMemoryRecorder";

export const MemoryInput = ({ memory, setMemory, photo, setPhoto, sessionId, error, setError, onSubmit }) => {
  const fileRef = useRef(null);
  const [preview, setPreview] = useState("");
  const recorder = useMemoryRecorder({ sessionId, onTranscript: (text) => { setMemory((current) => current ? `${current.trim()} ${text}` : text); setError(""); }, onError: setError });

  useEffect(() => {
    if (!photo) { setPreview(""); return undefined; }
    const url = URL.createObjectURL(photo);
    setPreview(url);
    return () => URL.revokeObjectURL(url);
  }, [photo]);

  const choosePhoto = (event) => {
    const file = event.target.files?.[0];
    event.target.value = "";
    if (!file) return;
    if (!["image/jpeg", "image/png", "image/webp"].includes(file.type) || file.size > 6 * 1024 * 1024) {
      setError("Choose a JPEG, PNG or WebP photo under 6 MB.");
      return;
    }
    setPhoto(file);
    setError("");
  };

  return <form className="memory-question" onSubmit={onSubmit} data-testid="memory-question-form">
    <div className="memory-copy"><h1 data-testid="memory-page-title">WHAT KIND OF<br/>CREATOR ARE YOU?</h1><p data-testid="memory-page-instruction">Tell Humn Ai your favorite life happening.</p></div>
    <div className="memory-input-shell">
      <textarea value={memory} onChange={(event) => { setMemory(event.target.value); setError(""); }} maxLength={1200} rows={5} placeholder="That one trip, meal, night, conversation or unexpected experience you still think about…" aria-label="Your favorite life happening" data-testid="memory-text-input" />
      <div className="memory-media-actions">
        <button type="button" onClick={recorder.toggle} aria-pressed={recorder.state === "recording"} disabled={recorder.state === "requesting" || recorder.state === "transcribing"} data-testid="memory-mic-button">{recorder.state === "recording" ? <Square/> : <Mic/>}<span>{recorder.state === "recording" ? "Stop" : recorder.state === "transcribing" ? "Listening…" : "Speak"}</span></button>
        <input ref={fileRef} type="file" accept="image/jpeg,image/png,image/webp" onChange={choosePhoto} data-testid="memory-photo-input" />
        <button type="button" onClick={() => fileRef.current?.click()} data-testid="memory-photo-button"><ImagePlus/><span>{photo ? "Photo added" : "Add Photo"}</span></button>
        {photo && <div className="memory-photo-chip" data-testid="memory-photo-preview">{preview && <img src={preview} alt="Attached memory"/>}<button type="button" onClick={() => setPhoto(null)} aria-label="Remove photo" data-testid="memory-photo-remove-button"><X/></button></div>}
      </div>
    </div>
    {error && <p className="memory-error" role="alert" data-testid="memory-error-message">{error}</p>}
    <button type="submit" className="memory-submit" disabled={memory.trim().length < 8 || recorder.state !== "idle"} data-testid="memory-submit-button">FIND MY CREATOR TYPE <span>✦</span></button>
    <small className="memory-enough" data-testid="memory-enough-note">One happening is enough.</small>
  </form>;
};